module.exports = __webpack_public_path__ + "img\\linkage_img.026b41cf.png";